import { createSelector } from "reselect";

const stateProducts = state => state.products.data;
const stateProductVideos = state => state.productVideos.data;

const getProductsAndVideos = createSelector(
  [stateProducts, stateProductVideos],
  (products, videos) => {
    return products.map(product => {
      return Object.assign({}, product, {
        videos: videos.filter(video => video.product_id === product.id)
      });
    });
  }
);

export { getProductsAndVideos };
